import * as React from 'react';
import { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';

import './style.scss';

const RootCauseSection = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="l-root-cause-section">
      <div className="container">
        <h2 className="section-title">Root cause analysis as a risk management tool</h2>

        <p>
          In 2019, the Councils introduced root cause analysis methodology as a practical risk management tool for
          associations to use to detect underlying causes of complaints and claims.
        </p>

        <p>
          Of the 79% of associations that implemented root cause analysis in 2021, 87% incorporated elements of root
          cause analysis into their risk management strategies, a 4% increase on 2020.
        </p>

        <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
          <div className="action">
            <Button isAction label="View more" icon="plus" onClick={() => setModalOpen(true)} />
          </div>

          <Modal type="image" isOpen={modalOpen} close={() => setModalOpen(false)}>
            <div className="image-desktop">
              <StaticImage
                src="./assets/charts.png"
                alt="Incorporating root cause analysis into risk management strategies"
              />
            </div>

            <div className="image-mob">
              <StaticImage
                src="./assets/charts-mob.jpg"
                alt="Incorporating root cause analysis into risk management strategies"
              />
            </div>

            <div className="sr-only">
              <p>Ask the WHYs</p>
              <ol>
                <li>Identify trends from data, e.g. the data identified a 20% increase in negligence claims</li>
                <li>
                  Implement root cause analysis using data sources
                  <ul>
                    <li>Cause of action, wy did the negligence occur?</li>
                    <li>
                      Practitioners taking on work beyond their expertise / capability, why are they taking on work in
                      areas beyond their expertise / capability?
                    </li>
                    <li>Lack of supervision of junior employees, why is there a lack of supervision?</li>
                    <li>COVID-19 working from home arrangements</li>
                  </ul>
                </li>
                <li>
                  Formulate risk management responses that target the identified root causes
                  <ul>
                    <li>Member audit / engagement systems</li>
                    <li>CPD courses</li>
                    <li>Issuing guidance to members and consumers</li>
                  </ul>
                </li>
                <li>
                  Monitor data and evaluate risk management strategies, e.g. Consider the following questions
                  <ul>
                    <li>What were your risk management strategy measures? How did they perform?</li>
                    <li>Do you see a difference in data obtained during the next period?</li>
                    <li>Can you identify any alternative responses that can be more effective?</li>
                    <li>How are you ensuring the risk management strategy is continuously improved?</li>
                  </ul>
                </li>
              </ol>

              <p>Sources:</p>
              <ul>
                <li>Complaints data</li>
                <li>Claims data</li>
                <li>Member surveys</li>
                <li>Reports</li>
                <li>Reports</li>
                <li>Media articles</li>
              </ul>
            </div>
          </Modal>
        </div>
      </div>
    </section>
  );
};

export default RootCauseSection;
